import { required, integer, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a table name.'), required)
      },
      branch_id: {
        required: helpers.withMessage(i18n.global.t('Please select branch.'), required)
      },
      zone_id: {
        required: helpers.withMessage(i18n.global.t('Please select a zone.'), required)
      },
      seat_capacity: {
        required: helpers.withMessage(i18n.global.t('Please enter a seat capacity.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      state: {
        required: helpers.withMessage(i18n.global.t('Please enter.'), required)
      }
    }
  }
};
